import notify from "devextreme/ui/notify";

export function showErrorMessage(message: string) {
	notify({
		message: message,
		type: 'error',
		displayTime: 4000,
		position: {
			at: "top center",
			my: 'top',
			of: '.header-component'
		},
		direction: 'down-stack'
	});

}

export function showSuccessMessage(message: string) {
	notify({
		message: message,
		type: 'success',
		displayTime: 2000,
		position: {
			at: "top center",
			my: 'top',
			of: '.header-component'
		},
		direction: 'down-stack'
	});
}